import { debugOn } from './main';
import { Utils } from './shared/extensions/utils.extension';

export const debug = (functionName: string, ...log: any[]) => {
    if (debugOn) {
        console.log(`${Utils.getFormatedTimestamp()} viewer log: ${functionName}`, ...log);
    }
};
